import { makeAutoObservable, runInAction, makeObservable, observable, action } from 'mobx';
import { RootStore } from './RootStore';


export interface DriverLocation {
    driver_id: number;
    name: string;
    latitude: number;
    longitude: number;
    heading: number;
    speed: number;
    is_available: boolean;
    is_online: boolean;
    last_updated: string;
    rating: number;
    trips_completed: number;
    accuracy: number;
    battery_level: number;
    vehicle_plate: string;
}

export class MainStore {

    driverLocations: DriverLocation[] = [];
    selectedDriverId: number | null = null;
    lastUpdateTime: Date | null = null;
    isLoading: boolean = false;

    private rootStore: RootStore;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
        makeObservable(this, {
            driverLocations: observable,
            selectedDriverId: observable,
            lastUpdateTime: observable,
            isLoading: observable,
            updateDriverLocations: action,
            updateDriverLocation: action,
            setSelectedDriver: action,
            setLoading: action
        });
    }


    updateDriverLocations(drivers: DriverLocation[]) {
        console.log(`MainStore: Actualizando ${drivers.length} conductores`);
        runInAction(() => {
            this.driverLocations = drivers;
            this.lastUpdateTime = new Date();
        });
    }


    updateDriverLocation(driver: DriverLocation) {
        runInAction(() => {
            const index = this.driverLocations.findIndex(d => d.driver_id === driver.driver_id);
            if (index >= 0) {
                this.driverLocations[index] = driver;
            } else {
                this.driverLocations.push(driver);
            }
            this.lastUpdateTime = new Date();
        });
    }

    setSelectedDriver(driverId: number | null) {
        runInAction(() => {
            this.selectedDriverId = driverId;
        });
    }

    setLoading(loading: boolean) {
        runInAction(() => {
            this.isLoading = loading;
        });
    }

    getDriverById(driverId: number): DriverLocation | undefined {
        return this.driverLocations.find(d => d.driver_id === driverId);
    }
}